module.exports = __webpack_public_path__ + "assets/b0321566ba8f1c25f5c35eb708d1ab6b.png";